module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['loader-container', _vm.containerClass],
    style: (_vm.containerStyle)
  }, [_c('div', {
    class: ['loader-content', ("loader-" + _vm.size)]
  }, [_c('div', {
    staticClass: "loader-logo"
  }, [_c('img', {
    class: ['logo-image', ("logo-" + _vm.size)],
    attrs: {
      "src": _vm.logoPath,
      "alt": "LiveRun Logo"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.showQuote) ? _c('div', {
    staticClass: "loader-quote"
  }, [_c('p', {
    staticClass: "quote-text"
  }, [_vm._v(_vm._s(_vm.currentQuote.quote))]), _vm._v(" "), _c('p', {
    staticClass: "quote-author"
  }, [_vm._v("— " + _vm._s(_vm.currentQuote.author))]), _vm._v(" "), (_vm.currentQuote.translation) ? _c('p', {
    staticClass: "quote-translation"
  }, [_vm._v(_vm._s(_vm.currentQuote.translation))]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-spinner"
  }, [_c('div', {
    staticClass: "spinner"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3872354a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loader/Loader.vue
// module id = 1698
// module chunks = 2